var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPurpleDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 51,
    viewBox: "0 0 114 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110.863,
    cy: 17.6188,
    r: 2.61882,
    fill: "#6F5AEF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.1493,
    cy: 17.6188,
    r: 2.61882,
    fill: "#6F5AEF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.6799,
    cy: 17.6188,
    r: 2.61882,
    fill: "#6F5AEF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.2104,
    cy: 17.6188,
    r: 2.61882,
    fill: "#6F5AEF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.7411,
    cy: 17.6188,
    r: 2.61882,
    fill: "#6F5AEF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.2717,
    cy: 17.6188,
    r: 2.61882,
    fill: "#6F5AEF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.8019,
    cy: 17.6188,
    r: 2.61882,
    fill: "#6F5AEF"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.3327,
    cy: 17.6188,
    r: 2.61882,
    fill: "#6F5AEF"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.6525,
    cy: 47.6872,
    r: 2.61882,
    fill: "#6F5AEF"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.6869,
    cy: 47.6872,
    r: 2.61882,
    fill: "#6F5AEF"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.7206,
    cy: 47.6872,
    r: 2.61882,
    fill: "#6F5AEF"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.7546,
    cy: 47.6872,
    r: 2.61882,
    fill: "#6F5AEF"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.7885,
    cy: 47.6872,
    r: 2.61882,
    fill: "#6F5AEF"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.8224,
    cy: 47.6872,
    r: 2.61882,
    fill: "#6F5AEF"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.61882,
    cy: 32.652,
    r: 2.61882,
    fill: "#6F5AEF"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.1493,
    cy: 32.652,
    r: 2.61882,
    fill: "#6F5AEF"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.6799,
    cy: 32.652,
    r: 2.61882,
    fill: "#6F5AEF"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.2104,
    cy: 32.652,
    r: 2.61882,
    fill: "#6F5AEF"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.7411,
    cy: 32.652,
    r: 2.61882,
    fill: "#6F5AEF"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.2717,
    cy: 32.652,
    r: 2.61882,
    fill: "#6F5AEF"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.8019,
    cy: 32.652,
    r: 2.61882,
    fill: "#6F5AEF"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.3327,
    cy: 32.652,
    r: 2.61882,
    fill: "#6F5AEF"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.863,
    cy: 32.652,
    r: 2.61882,
    fill: "#6F5AEF"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.6528,
    cy: 2.61882,
    r: 2.61882,
    fill: "#6F5AEF"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.61882,
    cy: 2.61882,
    r: 2.61882,
    fill: "#6F5AEF"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.6799,
    cy: 2.61882,
    r: 2.61882,
    fill: "#6F5AEF"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.7072,
    cy: 2.61882,
    r: 2.61882,
    fill: "#6F5AEF"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.7343,
    cy: 2.61882,
    r: 2.61882,
    fill: "#6F5AEF"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.7614,
    cy: 2.61882,
    r: 2.61882,
    fill: "#6F5AEF"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.7885,
    cy: 2.61882,
    r: 2.61882,
    fill: "#6F5AEF"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.8156,
    cy: 2.61882,
    r: 2.61882,
    fill: "#6F5AEF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleDots);
export default __webpack_public_path__ + "static/media/purple-dots.fefb080ab8af3ab64710a638f8e085eb.svg";
export { ForwardRef as ReactComponent };